import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	width: 100%;
	padding-left: 40px;
`;

const StyledHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: calc(100% - 20px);

	& > ${Text} {
		font-style: italic;
		font-weight: 400;
		font-size: 16px;
		line-height: 18px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledOfferList = styled.div`
	width: 100%;
	padding-right: 10px;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		width: 10px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: rgba(255, 255, 255, 0.1);

		&:hover {
			background-color: rgba(255, 255, 255, 1);
		}
	}
`;

const StyledNotActiveContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;

	${Text} {
		font-style: italic;
		font-weight: 400;
		font-size: 16px;
		line-height: 18px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledBottomContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: calc(100% - 20px);
	margin-top: 20px;
`;

const StyledTaxContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 10px;
	height: 40px;
	padding: 0 10px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;

	${Text} {
		font-weight: 400;
		font-size: 16px;
		line-height: 18px;
		color: #ffffff;

		&:first-child {
			opacity: 0.25;
		}
	}
`;

const StyledCashInputContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: calc(100% - 20px);
	padding: 20px 0;
	border: solid rgba(255, 255, 255, 0.1);
	border-width: 0 0 1px 0;

	input {
		width: 260px;
	}
`;

export {
	StyledBottomContainer,
	StyledCashInputContainer,
	StyledContainer,
	StyledHead,
	StyledNotActiveContainer,
	StyledOfferList,
	StyledTaxContainer,
};
